import { PATHS } from "constants/Constants";
import CustomerAddPage from "features/crm/components/CustomerAddPage";
import CustomerDetailPage from "features/crm/subFeatures/contactDetailPage/CustomerDetailPage";
import CustomerListPage from "features/crm/subFeatures/contactListPage/CustomerListPage";
import Dashboard from "features/dashboard/components/Dashboard";
import DataLoadingScreen from "features/dashboard/components/DataLoadingScreen";
import DealDetailPage from "features/deal/components/DealDetailPage";
import DealListPage from "features/deal/components/DealListPage";
import FormGen from "features/forms/components/FormGen";
import MultiDealer from "features/forms/components/MultiDealer";
import InventoryAddPage from "features/inventory/components/InventoryAddPage";
import InventoryAdvertisingPage from "features/inventory/components/InventoryAdvertisingPage";
import InventoryAppraisalPage from "features/inventory/components/InventoryAppraisalPage";
import InventoryDetailsPage from "features/inventory/components/InventoryDetailPage";
import InventoryListPage from "features/inventory/components/InventoryListPage";
import ReportsPage from "features/reports/ReportsPage";
import SettingsPage from "features/settings/components/SettingsPage";
import VendorPage from "features/settings/subFeatures/vendor/VendorPage";
import Login from "features/userManagement/components/Login.js";
//import PaymentTerminalPage from "services/digitzsService/PaymentTerminalPage";

import DealerGPT from "components/dealerGPT/DealerGPT";
import DealAddPage from "features/deal/components/DealAddPage";
import QuickQuoteDeal from "features/deal/subFeatures/quickQuote/QuickQuoteDeal";
import AccountDetailPage from "../account/AccountDetailPage";
import AccountListPage from "../account/AccountListPage";
import OnlineLeadDetailsPage from "../features/crm/subFeatures/onlineLeadDetailsPage/OnlineLeadDetailsPage";
import DealSearchList from "../features/deal/components/DealSearchList";
import InventorySearchList from "../features/deal/subFeatures/inventory/InventorySearchList";
import {
	useDigitzsMerchantId,
	useFromLocations,
	useFromUser,
} from "../stores/LocalStorageHelper";
import AccountAddPage from "../account/AccountAddPage";
import AccountPayments from "../account/AccountPayments";
import ScheduledList from "../features/crm/components/ScheduledList";
import AcctTrackPayments from "../account/AcctTrackPayments";
import AllScheduledPayments from "../account/AllScheduledPayments";
import AccountModificationPage from "../account/AccountModificationPage";
import AccountSearchList from "../account/AccountSearchList";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";

const usePublicRoutes = () => {
	const locationID = useFromUser("locationID");
	const merchantId = useDigitzsMerchantId();
	let bhph = 0;
	bhph = useFromLocations("fn") === 1 || useFromLocations("ls") === 1 ? 1 : 0;
	// if ([4757, 6730, 7942, 5456, 7906, 7464, 7664, 4575].includes(locationID)) {
	// 	bhph = 1;
	// } else {
	// 	bhph = 0;
	// }

	// if (locationID === 4757 || locationID === 6730) bhph = 1;
	// else bhph = 0;

	const privileges = useUserBhphPrivileges();
	const p = privileges();
	const createNewAccount = p.createNewAccount;
	const accessBhph = p.accessBhph;

	return [
		{
			path: PATHS.DATA_LOADING,
			name: "Data Loading",
			icon: "nc-icon nc-layout-11",
			component: DataLoadingScreen,
			layout: "",
			invisible: true,
		},
		{
			path: PATHS.DASHBOARD,
			name: "Dashboard",
			icon: "nc-icon nc-layout-11",
			component: Dashboard,
			layout: "",
		},
		{
			path: PATHS.LOGIN,
			name: "Login",
			icon: "nc-icon nc-simple-add",
			component: Login,
			layout: "",
			invisible: true,
		},
		{
			collapse: true,
			name: "Deals",
			icon: "nc-icon nc-briefcase-24",
			state: "dealCollapse",
			views: [
				{
					path: PATHS.DEAL_LIST,
					name: "View Deals",
					icon: "nc-icon nc-bullet-list-67",
					component: DealListPage,
					layout: "",
				},
				{
					path: PATHS.DEAL_ADD,
					name: "New Deal",
					icon: "nc-icon nc-simple-add",
					component: DealAddPage,
					layout: "",
				},
				{
					path: PATHS.QuickQuote,
					name: "Quick Quote",
					icon: "nc-icon nc-sound-wave",
					component: QuickQuoteDeal,
					layout: "",
				},
				{
					path: PATHS.DEAL_DETAIL,
					name: "Deal Detail",
					component: DealDetailPage,
					layout: "",
					invisible: true,
				},
				{
					path: PATHS.DEAL_SEARCH_LIST,
					name: "Quick Search",
					icon: "nc-icon nc-zoom-split",
					component: DealSearchList,
					layout: "",
					invisible: false,
				},
			],
		},
		{
			collapse: true,
			name: "CRM",
			icon: "nc-icon nc-single-02",
			state: "contactCollapse",
			views: [
				{
					path: PATHS.CUSTOMER_LIST,
					name: "View List",
					icon: "nc-icon nc-bullet-list-67",
					component: CustomerListPage,
					layout: "",
				},
				{
					path: PATHS.CUSTOMER_ADD,
					name: "Add Customer",
					icon: "nc-icon nc-simple-add",
					component: CustomerAddPage,
					layout: "",
				},
				{
					path: PATHS.LEAD_ADD,
					name: "Add Lead",
					icon: "nc-icon nc-simple-add",
					component: OnlineLeadDetailsPage,
					layout: "",
				},
				{
					path: PATHS.SCHEDULE_TASK,
					name: "Scheduled Task",
					icon: "nc-icon nc-calendar-60",
					component: ScheduledList,
					layout: "",
				},
				{
					path: PATHS.CUSTOMER_DETAIL,
					name: "Customer Detail",
					component: CustomerDetailPage,
					layout: "",
					invisible: true,
				},
				{
					path: PATHS.LEAD_DETAIL,
					name: "Lead Detail",
					component: CustomerDetailPage,
					layout: "",
					invisible: true,
				},
				// {
				// 	path: PATHS.CUSTOMER_SEARCH_LIST,
				// 	name: "Quick Search",
				// 	icon: "nc-icon nc-search-icon",
				// 	component: InventorySearchList,
				// 	layout: "",
				// 	invisible: false,
				// },
			],
		},
		{
			collapse: true,
			name: "Inventory",
			icon: "nc-icon nc-delivery-fast",
			state: "inventoryCollapse",
			views: [
				{
					path: PATHS.INVENTORY_LIST,
					name: "View Inventory",
					icon: "nc-icon nc-bullet-list-67",
					component: InventoryListPage,
					layout: "",
				},
				{
					path: PATHS.INVENTORY_ADD,
					name: "Add Inventory",
					icon: "nc-icon nc-simple-add",
					component: InventoryAddPage,
					layout: "",
				},
				{
					path: PATHS.INVENTORY_ADVERTISING,
					name: "Advertising",
					icon: "nc-icon nc-world-2",
					component: InventoryAdvertisingPage,
					layout: "",
				},
				{
					path: PATHS.INVENTORY_APPRAISAL,
					name: "Appraisal",
					icon: "nc-icon nc-tag-content",
					component: InventoryAppraisalPage,
					layout: "",
				},
				{
					path: PATHS.INVENTORY_DETAIL,
					name: "Inventory Details",
					component: InventoryDetailsPage,
					layout: "",
					invisible: true,
				},
				{
					path: PATHS.INVENTORY_SEARCH_LIST,
					name: "Quick Search",
					icon: "nc-icon nc-zoom-split",
					component: InventorySearchList,
					layout: "",
					invisible: false,
				},
			],
		},
		{
			collapse: true,
			name: "Financing",
			icon: "nc-icon nc-briefcase-24",
			state: "bhphCollapse",
			invisible: bhph === 0 || !accessBhph ? true : false,
			//invisible: true,
			views: [
				{
					path: PATHS.ACCT_LIST,
					name: "View Acounts",
					icon: "nc-icon nc-bullet-list-67",
					component: AccountListPage,
					layout: "",
				},
				{
					path: PATHS.ACCT_DETAIL,
					name: "View Details",
					icon: "nc-icon nc-bullet-list-67",
					component: AccountDetailPage,
					layout: "",
					invisible: true,
				},
				{
					path: PATHS.ACCT_MODIFY,
					name: "View Details",
					icon: "nc-icon nc-bullet-list-67",
					component: AccountModificationPage,
					layout: "",
					invisible: true,
				},

				{
					path: PATHS.ACCT_ADD,
					name: "New Account",
					icon: "nc-icon nc-simple-add",
					component: AccountAddPage,
					layout: "",
					invisible: !createNewAccount,
				},
				{
					path: PATHS.ACCT_SEARCH_LIST,
					name: "Quick Search",
					icon: "nc-icon nc-zoom-split",
					component: AccountSearchList,
					layout: "",
					invisible: false,
				},
				{
					path: PATHS.ACCT_PAYMENT_LIST,
					name: "Payment Tracking",
					icon: "nc-icon nc-bullet-list-67",
					component: AcctTrackPayments,
					layout: "",
					invisible: false,
				},
			],
		},
		{
			path: PATHS.REPORTS,
			name: "Reports",
			icon: "nc-icon nc-chart-bar-32",
			component: ReportsPage,
			layout: "",
		},
		{
			path: PATHS.VENDORS,
			name: "Companies",
			icon: "nc-icon nc-circle-10",
			component: VendorPage,
			layout: "",
		},
		{
			path: PATHS.PAYMENT_TERMINAL,
			name: "Scheduled PMT",
			icon: "nc-icon nc-credit-card",
			component: AllScheduledPayments,
			layout: "",
		},
		{
			path: PATHS.DEALER_GPT,
			name: "DealerGPT",
			icon: "nc-icon nc-chat-33",
			component: DealerGPT,
			layout: "",
		},
		{
			path: PATHS.SETTINGS,
			name: "Settings",
			icon: "nc-icon nc-settings-gear-65",
			component: SettingsPage,
			layout: "",
		},
		{
			path: PATHS.FormGen,
			name: "FormGen",
			icon: "nc-icon nc-layout-11",
			component: FormGen,
			layout: "",
			invisible: true,
		},
		{
			path: PATHS.MultiDealer,
			name: "MultiDealer",
			icon: "nc-icon nc-layout-11",
			component: MultiDealer,
			layout: "",
			invisible: true,
		},
		{
			collapse: true,
			name: "Tranning Videos",
			icon: "nc-icon nc-single-02",
			state: "tranningCollapse",
			views: [
				{
					path: "/training/inventory",
					name: "Add Inventory Video",
					icon: "nc-icon nc-tv-2",
					layout: "",
					videoUrl:
						"https://dealernetwork.com/images/TrainingVideos/DCAddInventory.mp4",
				},
				{
					path: "/training/deal",
					name: "Deal Structure Video",
					icon: "nc-icon nc-tv-2",
					layout: "",
					videoUrl:
						"https://dealernetwork.com/images/TrainingVideos/DCDealStructure.mp4",
				},
				{
					path: "/training/lead",
					name: "Add Lead Video",
					icon: "nc-icon nc-tv-2",
					layout: "",
					videoUrl:
						"https://dealernetwork.com/images/TrainingVideos/DCAddlead.mp4",
				},
				{
					path: "/training/bhph",
					name: "BHPH Video",
					icon: "nc-icon nc-tv-2",
					layout: "",
					videoUrl:
						"https://dealernetwork.com/images/TrainingVideos/BHPHVideo.mp4",
				},
			],
		},
	];
};

export default usePublicRoutes;
